import React from 'react';
import { Card } from 'react-bootstrap';
import face_logo from '../../../assets/logos/facebook.png'
import FacebookBusinessLoginButton from './loginButton';
import Swal from 'sweetalert2';
import IntegracoesService from '../../../services/IntegracoesService';
import { trackPromise } from "react-promise-tracker";

export default function Facebook() {
    const responseFacebook = (response) => {
        if(response.code) {
            trackPromise(IntegracoesService.subscribeFacebookPages(response.code)
                .then(res => {
                    Swal.fire({
                        titleText: "Sucesso!",
                        text: "Páginas integradas com sucesso!",
                        icon: 'success'
                    })
                }).catch(err => Swal.fire({
                    titleText: "Erro",
                    text: "Houve um problema ao integrar as páginas do usuário " + err,
                    icon: 'error'
                })))
        }
    }

    return <>
        <Card.Body>
            <Card.Title><Card.Img src={face_logo}/></Card.Title>
            <Card.Text>
                Rede Social
            </Card.Text>
        </Card.Body>
        <FacebookBusinessLoginButton
            version="23.0"
            appId="930897277557740"
            onSuccess={responseFacebook}
            configId={785401523880221}
        />
    </>
}